export const enum ANSWER_TYPES {
  VIDEO = 'video',
  TEXT = 'text',
  MULTIPLE = 'multiple_choice',
  SINGLE = 'single_choice',
}

export interface IQuestion {
  question: string;
  numOfRetakes: number;
  partDuration: number;
  thinkingTime: number;
  timeLimit?: number; // TODO: check if can be remvoed
  videoQuestion?: string;
  description?: string;
}

export interface IQuestionDefault extends IQuestion {
  answerType?: `${ANSWER_TYPES.VIDEO}`;
}

export interface IQuestionTextAnswer extends IQuestion {
  answerType: `${ANSWER_TYPES.TEXT}`;
  config?: {
    minChars?: number;
    maxChars?: number;
    antiCheat?: boolean;
  };
}

export interface IMultipleChoiceOptionDefinition {
  id: string;
  label: string;
}

export interface IQuestionChoiceAnswer extends IQuestion {
  config?: {
    shuffle?: boolean;
    answers: IMultipleChoiceOptionDefinition[];
  };
}

export interface IQuestionMultipleAnswer extends IQuestionChoiceAnswer {
  answerType: `${ANSWER_TYPES.MULTIPLE}`;
  config?: {
    minAnswers?: number;
    maxAnswers?: number;
  } & IQuestionChoiceAnswer['config'];
}

export interface IQuestionSingleAnswer extends IQuestionChoiceAnswer {
  answerType: `${ANSWER_TYPES.SINGLE}`;
}

type leanQuestion<T> = Omit<T, 'numOfRetakes' | 'partDuration' | 'thinkingTime'> & { attempts?: number, duration?: number, thinkingTime?: number };

export type ALL_JOB_QUESTIONS_TYPE =
  | IQuestionDefault
  | IQuestionTextAnswer
  | IQuestionMultipleAnswer
  | IQuestionSingleAnswer;

export type ASSESSMENT_QUESTIONS_TYPE = Exclude<ALL_JOB_QUESTIONS_TYPE, IQuestionDefault>;

export type IClientQuestion =
  | leanQuestion<IQuestionDefault>
  | leanQuestion<IQuestionTextAnswer>
  | leanQuestion<IQuestionMultipleAnswer>
  | leanQuestion<IQuestionSingleAnswer>;

export interface IJob {
  language?: string; // apiKey -> job -> candidate -> suggested -> const 'en'
  // overlay?: string; // job -> <defaultJob>
  transcriptLanguage?: string; // job -> suggested -> const 'en-US'
  title?: string; // job -> suggested -> const 'Default job'
  company?: string; // job -> apiKey
  job_id?: string; // candidate -> job -> suggested -> <new Default Job>
  logo?: string; // job -> suggested
  questions?: ALL_JOB_QUESTIONS_TYPE[]; // job -> <Default job>(if selected by the DB skip to suggested) -> suggested
  old_jobID?: string; // suggested maybe => TODO: check if needed
  //   cb_subscription_id?: string;
  //   videos_count?: number;
  //   isSubscription?: boolean;
  //   cb_candidate_balance_total?: number;
  termsUrl?: string;
  privacyUrl?: string;
  //   backgroundImage?: string; // job
  apiKey?: string;
  //   slug: string;
  //   companySlug: string;
  company_id?: string; // apiKey -> job -> candidate
  //   config: IJobConfig;
  //   deadlineDate?: string | Date | number;
  //   experience?: string;
  //   jobDescription?: string;
  jobID?: string;
  //   url?: string;
  //   videos?: IVideo[];
  //   reminderValues: string[];
  //   skills: string[];
  //   kanban: IJobKanban[];
  //   permissions: IJobPermission[];
  //   categories: string[];
  //   introVideo?: string;
  //   status: string;
  //   creatorId: string;
  //   creatorDetails?: {
  //     name?: string;
  //     email: string;
  //     origin?: string;
  //   };
  //   direct_link?: string;
  //   type?: string;
  //   integration_id?: string;
  //   integration_name?: string;
  //   api_created?: boolean;
  //   location?: string;
  //   updatedAt: string | Date | number;
  //   createdAt: string | Date | number;
  //   toDelete?: boolean;
  //   expiry_email_sent: boolean | undefined;
  //   region?: string;
  //   intelligenceSurvey?: IJobIntelligenceSurvey[];
  //   intelligenceIDs?: number[];
  //   jobInputFields: {
  //     label: string;
  //     type: string;
  //     required: boolean;
  //     fieldName: string;
  //   }[];
  //   isFake?: boolean;
  //   quiz_id?: string;
}

export type IClientJob = Omit<IJob, 'questions'> & { questions?: IClientQuestion[] };
